import { render, staticRenderFns } from "./DashboardDinamicComponent.vue?vue&type=template&id=41fe97ea"
import script from "./DashboardDinamicComponent.vue?vue&type=script&lang=js"
export * from "./DashboardDinamicComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\capredena\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41fe97ea')) {
      api.createRecord('41fe97ea', component.options)
    } else {
      api.reload('41fe97ea', component.options)
    }
    module.hot.accept("./DashboardDinamicComponent.vue?vue&type=template&id=41fe97ea", function () {
      api.rerender('41fe97ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/Views/DashboardDinamicComponent.vue"
export default component.exports